import { themeColors, brand } from '../theme'

export function useChartTheme() {
  const colors = themeColors

  return {
    colors,
    // Recharts axis/grid colors
    axis: {
      stroke: colors.textDimmed,
      tick: { fill: colors.textMuted, fontSize: 11, fontFamily: "'Instrument Sans', sans-serif" },
    },
    grid: {
      stroke: '#E2E2DD',
      strokeDasharray: '3 3',
    },
    tooltip: {
      bg: '#FFFFFF',
      border: '#E2E2DD',
      text: colors.text,
      label: colors.textSecondary,
    },
    // Series palette
    palette: [
      brand.green,      // #1A7A4C
      brand.gold,       // #EAB308
      brand.greenLight,  // #2a8a87
      '#3d6fa8',         // blue
      '#b5aa9d',         // gray
      '#857b71',         // darkGray
    ],
    // Card styling props
    card: {
      bg: colors.bgCard,
      backdropFilter: 'none',
      border: colors.border,
      boxShadow: 'none',
    },
  }
}
